import React from 'react'
import styles from "../vendorprofile/myprofile.module.css"
import AllVenOrderTab from '../../Components/orderscomp/AllVenOrderTab'
import VendorProfileMenu from '../../Components/vendorprofilemenu/VendorProfileMenu'
import Myprofile from '../../../CustomerDash/Pages/myprofile/Myprofile'

const AllVenOrders = () => {
    return (
        <>
            <Myprofile>
               
                <AllVenOrderTab />
            </Myprofile>
        </>
    )
}

export default AllVenOrders